import React, { useState } from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { useDispatch } from "react-redux";
import { upload } from "../redux/referralCategoriesSagas";

export const UploadReferrals = ({ onClose }) => {
  const dispatch = useDispatch();

  const [error, setError] = useState("");
  const [file, setFile] = useState("");

  const onFileUpload = (e) => {
    let file = e.target.files[0];

    if (
      file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.type !== "application/vnd.ms-excel"
    ) {
      setError("Please select correct file type.");
      setFile("");
    } else {
      setError("");
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadstart = () => setFile("");
      reader.onload = () => setFile(reader.result);
    }
  };

  const primaryBtnHandler = () => {
    dispatch(upload(file));
    onClose();
  };

  return (
    <>
      <MainModal
        isOpen
        onClose={onClose}
        parentSelector=".referral-categories"
        primaryButtonText="Upload"
        primaryBtnHandler={primaryBtnHandler}
        primaryButtonClass="primary"
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        secondaryBtnClass="secondary"
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Import Referral Categories"
        isAdminPanel={false}
      >
        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="help-block">* {error}</div>}
      </MainModal>
    </>
  );
};
